import styled, { CSSProperties } from "styled-components";

// TEXT

// STYLES
export const Flex = styled.div<Props>`
  display: flex;
  gap: ${({ $gap = "1.5rem" }) => $gap};
  flex-flow: ${({ $flow }) => $flow};
  flex-grow: ${({ $grow }) => $grow};
  align-items: ${({ $align }) => $align};
  justify-content: ${({ $justify }) => $justify};
  max-width: ${({ $maxWidth }) => $maxWidth};
  min-height: ${({ $minHeight }) => $minHeight};
  width: ${({ $fullWidth }) => $fullWidth && "100%"};
  height: ${({ $fullHeight }) => $fullHeight && "100%"};
`;

// DATA

// TYPES
type Props = {
  $gap?: CSSProperties["gap"];
  $flow?: CSSProperties["flexFlow"];
  $grow?: CSSProperties["flexGrow"];
  $align?: CSSProperties["alignItems"];
  $justify?: CSSProperties["justifyContent"];
  $maxWidth?: CSSProperties["maxWidth"];
  $minHeight?: CSSProperties["minHeight"];
  $fullWidth?: boolean;
  $fullHeight?: boolean;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
